import { Flex } from "rebass/styled-components";
import styled from "styled-components";
import { Subheader } from "../../../../../Components/Text";

export const EnableSignatureCardWrapper: any = styled(Flex)`
  background: ${(props: any) => props.theme.colors.darkerNed};
  border-radius: 10px 10px 10px 10px;
  padding: 15px;
  flex-direction: column;
`;

export const StyledSubheader = styled(Subheader)`
  transition: color 100ms ease;
  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.envy};
  }
`;
